module.exports = __webpack_public_path__ + "img/stormOfSteel.43d90c0c.png";